export class SalesIQAuth {}
//# sourceMappingURL=SalesIQAuth.js.map